import DeploymentsSection from '@/views/deployments/DeploymentsSection.vue';
import Deployments from '@/views/deployments/Deployments.vue';
import DeploymentCreate from '@/views/deployments/DeploymentCreate.vue';
import Deployment from '@/views/deployments/Deployment.vue';
import DeploymentDetails from '@/views/deployments/tabs/DeploymentDetails.vue';
import DeploymentDelete from '@/views/deployments/tabs/DeploymentDelete.vue';

export default [
  {
    path: '/deployments',
    component: DeploymentsSection,
    meta: {
      breadcrumb: {
        linkName: 'deployments.index',
        linkText: 'Deployments',
      },
    },
    children: [
      {
        path: '',
        component: Deployments,
        name: 'deployments.index',
      },
      {
        path: 'create',
        component: DeploymentCreate,
        name: 'deployments.index.create',
      },
      {
        path: ':id',
        component: Deployment,
        meta: {
          breadcrumb: {
            linkName: 'deployments.index.detail',
            linkText: 'Deployment Summary',
          },
        },
        children: [
          {
            path: '',
            name: 'deployments.index.detail',
            component: DeploymentDetails,
          },
          {
            path: 'delete',
            name: 'deployments.index.detail.delete',
            component: DeploymentDelete,
          },
        ],
      },
    ],
  },
];
